import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormularioCliente } from '../../models/formcliente.component';
import { Observable } from 'rxjs';
import { ClienteNinet } from '../../models/clienteninet.component';
import { environment } from 'src/environments/environment';

@Injectable()
export class ClienteService {

  private URL:string = `${environment.URL}/cliente`;

  constructor(public http: HttpClient, public router: Router) { }


  guardarCliente(formularioCliente: FormularioCliente): Observable<any> {
    return this.http.post<any>(`${this.URL}/addcliente`, formularioCliente);
  }

  guardarClienteNinet(clienteNinet: ClienteNinet): Observable<any> {
    return this.http.post<any>(`${this.URL}/addclienteninet`, clienteNinet);
  }

  buscaAfiliadoInkaFarma(request: any) {
    return this.http.post(`${this.URL}/buscaAfiliadoInkaFarma`, request);
  }

  obtenerGanadores(){
    return this.http.get<any>('assets/mock/json/ganadores-milsoles.json');
  }

}
